import React from 'react';
import {Row, Column} from '../../global/grid/grid';
import Image from '../../global/media/Image';

import { InProgressWrapper, Title } from './styled-components';

const InProgress = ({data, imageDictionary}) => {
  return (
    <InProgressWrapper>
        <Column cw={12} style={{textAlign: 'center'}}>
            <Title>{data.title}<span className="carrot"></span></Title>
        </Column>
        {
            data.cities.map( (city, index) => {
                return (
                    <Column key={index} className="inProgressItem" cw={4} offset={index === 0 ? 2 : 0} style={{position: 'relative', display: 'flex', flexDirection: 'column'}}>
                        <div className="city">{city.city}</div>
                        <div className="state">{city.state}</div>
                        <div style={{width: '100%', background: 'white', position: 'relative'}}>
                            <Image aspectHeight={5} aspectWidth={4} sizes={imageDictionary[city.image].sizes} style={{opacity: '0.5'}}/>
                            <div className="whiteMask"></div>
                            <div className={`colorBlock ${index === 0 ? 'left' : 'right'}`}>
                                <div className="stripes"></div>
                            </div>
                        </div>
                        <div className="initialsHolder">
                            <span style={{transform: 'translate3d(0, -30px, 0) rotate(-20deg)'}}>{city.initials[0]}</span>
                            <span style={{transform: 'translate3d(0, 120px, 0) rotate(15deg)'}}>{city.initials[1]}</span>
                        </div>                        
                    </Column>
                )
            } )
        }  
    </InProgressWrapper>
  )
}

export default InProgress;



// WEBPACK FOOTER //
// ./src/components/modules/InProgress/InProgress.js